// extracted by mini-css-extract-plugin
export default {"iconsWrapper":"profileSetting_iconsWrapper__r+eqH","profileIcon":"profileSetting_profileIcon__XH6WR","modifyIcon":"profileSetting_modifyIcon__Wv59H"};